function autoInc() {
  var seed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  return function () {
    return ++seed;
  };
}

export default autoInc();


//////////////////
// WEBPACK FOOTER
// ./~/react-onclickoutside/es/uid.js
// module id = 919
// module chunks = 0